import { clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const mergeClasses = extendTailwindMerge({
  prefix: 'tw',
  extend: {
    // A role sets the whole font. A caller's explicit role replaces the primitive's role.
    classGroups: { typography: [{ type: [() => true] }] },
  },
});

export function cn(...inputs) {
  return mergeClasses(clsx(inputs));
}
